import _defineProperty from "@babel/runtime/helpers/defineProperty";
export let ResilienceMechanism;

(function (ResilienceMechanism) {
  ResilienceMechanism["localstorage"] = "@segment/localstorage-retry";
  ResilienceMechanism["indexeddb"] = "indexeddb";
  ResilienceMechanism["memory"] = "memory";
})(ResilienceMechanism || (ResilienceMechanism = {}));

export class MetricsCollector {
  constructor() {
    _defineProperty(this, "itemsDiscardedByRetry", 0);

    _defineProperty(this, "duplicateEventCount", 0);

    _defineProperty(this, "eventCount", 0);

    _defineProperty(this, "localstorageDuplicateCount", 0);

    _defineProperty(this, "itemsDiscardedByOverflow", 0);

    _defineProperty(this, "resilienceMechanism", ResilienceMechanism.localstorage);
  }

  addToItemsDiscardedByRetryCounter() {
    this.itemsDiscardedByRetry++;
  }

  addToDuplicateEventCounter() {
    this.duplicateEventCount++;
  }

  addToEventCount() {
    this.eventCount++;
  }

  addToLocalstorageDuplicateCount() {
    this.localstorageDuplicateCount++;
  }

  addToItemsDiscardedByOverflowCounter() {
    this.itemsDiscardedByOverflow++;
  }

  setResilienceMechanism(mechanism) {
    this.resilienceMechanism = mechanism;
  }

  subtractFromMetrics(sentMetrics) {
    this.itemsDiscardedByRetry = Math.max(this.itemsDiscardedByRetry - sentMetrics.itemsDiscardedByRetry, 0);
    this.duplicateEventCount = Math.max(this.duplicateEventCount - sentMetrics.duplicateEventCount, 0);
    this.eventCount = Math.max(this.eventCount - sentMetrics.eventCount, 0);
    this.localstorageDuplicateCount = Math.max(this.localstorageDuplicateCount - sentMetrics.localstorageDuplicateCount, 0);
    this.itemsDiscardedByOverflow = Math.max(this.itemsDiscardedByOverflow - sentMetrics.itemsDiscardedByOverflow, 0);
  }

  getMetricsPayload() {
    return {
      itemsDiscardedByRetry: this.itemsDiscardedByRetry,
      duplicateEventCount: this.duplicateEventCount,
      eventCount: this.eventCount,
      localstorageDuplicateCount: this.localstorageDuplicateCount,
      itemsDiscardedByOverflow: this.itemsDiscardedByOverflow,
      resilienceMechanism: this.resilienceMechanism
    };
  }

}
let cachedMetricsClient = null;
export default (() => {
  if (!cachedMetricsClient) {
    cachedMetricsClient = new MetricsCollector();
  }

  return cachedMetricsClient;
});